import {
  FETCH_SERVICE_VISIT_MECHANICS,
  FETCH_SERVICE_VISIT_PRIORITIES,
  FETCH_SERVICE_VISIT_SERVICE_LOCATIONS,
  FETCH_SERVICE_VISIT_STATUSES
} from "@/modules/service-visits/store/service-visits.module";

export const serviceVisitFilterOptionsMixin = {
  data() {
    return {
      filters: {
        dateFrom: null,
        dateTo: null,
        serviceLocationIds: [],
        mechanicIds: [],
        priorityIds: [],
        statusIds: []
      },
      mechanics: [],
      priorities: [],
      serviceLocations: [],
      filterStatuses: []
    };
  },
  computed: {
    canShowServiceVisitMechanicFilter() {
      return this.checkIfUserHasPermission(["service-visits-show"]);
    },
    activeServiceVisitFilters() {
      return Object.keys(this.filters).reduce((params, key) => {
        const value = this.filters[key];

        if (Array.isArray(value) && value.length) {
          params[key] = value;
        } else if (value !== null && value !== undefined && value !== "") {
          params[key] = value;
        }

        return params;
      }, {});
    },
    hasActiveServiceVisitFilters() {
      return Object.keys(this.activeServiceVisitFilters).length > 0;
    }
  },
  methods: {
    loadServiceVisitFilterOptions({ includeStatuses = true, includeMechanics = true } = {}) {
      const requests = [
        this.$store.dispatch(FETCH_SERVICE_VISIT_PRIORITIES),
        this.$store.dispatch(FETCH_SERVICE_VISIT_SERVICE_LOCATIONS)
      ];

      if (includeStatuses) {
        requests.push(this.$store.dispatch(FETCH_SERVICE_VISIT_STATUSES));
      } else {
        requests.push(Promise.resolve(null));
      }

      if (includeMechanics && this.canShowServiceVisitMechanicFilter) {
        requests.push(this.$store.dispatch(
          FETCH_SERVICE_VISIT_MECHANICS,
          this.$url.transformParams({ length: 1000, start: 0 })
        ));
      } else {
        requests.push(Promise.resolve(null));
      }

      return Promise.all(requests).then(([priorities, serviceLocations, statuses, mechanics]) => {
        this.priorities = this.extractServiceVisitFilterItems(priorities);
        this.serviceLocations = this.extractServiceVisitFilterItems(serviceLocations).map(location => ({
          ...location,
          name: [location.name, location.location].filter(Boolean).join(" - ")
        }));
        this.filterStatuses = this.extractServiceVisitFilterItems(statuses);
        this.mechanics = this.extractServiceVisitFilterItems(mechanics).map(user => ({
          ...user,
          name: `${user.firstName || ""} ${user.lastName || ""}`.trim()
        }));
      });
    },
    resetServiceVisitFilters() {
      this.filters = {
        dateFrom: null,
        dateTo: null,
        serviceLocationIds: [],
        mechanicIds: [],
        priorityIds: [],
        statusIds: []
      };
    },
    extractServiceVisitFilterItems(response) {
      if (!response || !response.data) {
        return [];
      }

      if (Array.isArray(response.data)) {
        return response.data;
      }

      return response.data.items || [];
    }
  }
};
